var _path, _path2, _path3, _path4, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNotebooksNoSpiral = function SvgNotebooksNoSpiral(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc441",
    d: "M103.27 21.34h287.67v256H103.27zM449.87 21.34h-16.7v256h60.7v-212a44 44 0 0 0-44-44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4abe0",
    d: "M390.94 277.34H103.27v258.64h43.22v-.22h41.71v.22h202.74V277.34zM433.17 536h16.7a44 44 0 0 0 44-44V277.34h-60.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M404.14 10.78h-9.2a4 4 0 0 0-4 4v535.67a4 4 0 0 0 4 4h9.2zM433.17 277.34V14.78a4 4 0 0 0-4-4h-8.33v543.67h8.33a4 4 0 0 0 4-4V277.34z",
    fill: "#d6842d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M404.14 10.78h16.7v543.68h-16.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0592b",
    d: "M146.49 535.76v56.31l20.85-13.56 20.86 15.64v-58.39h-41.71z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotebooksNoSpiral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notebooks_no_spiral.3a292bc8.svg";
export { ForwardRef as ReactComponent };